//External
import Login from "../../components/login";
import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { setShowOtpBlock } from "store/actions";

/*******************
@Purpose : Used for alert modal
@Parameter : { show, }
@Author : INIC
******************/
function LoginModal({ show, handleClose }) {
  const dispatch = useDispatch();
  const showOtpBlock = useSelector((state) => state.ui.showOtpBlock);

  useEffect(() => {
    if (show) {
      document.getElementById("phone").focus();
    }
  }, [show]);

  /*******************
  @purpose : Render HTML/ React Components
  @Author : INIC
  ******************/
  return (
    <>
      {show && (
        <Modal
          show={show}
          onHide={() => handleClose("remove")}
          centered
          className="login-modal"
        >
          <Modal.Header
            closeButton
            className={showOtpBlock ? "otp-header" : "login-header"}
          >
            {showOtpBlock && (
              <div
                className="close otp-back cursor-pointer"
                onClick={() => dispatch(setShowOtpBlock(false))}
              >
                <span className="icon icon-arrow-left font-14"></span>
              </div>
            )}

            <Modal.Title id="contained-modal-title-vcenter">
              <h2 className="mb-0">
                {showOtpBlock ? "OTP Verification" : "Log in or Sign up"}
              </h2>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Login handleClose={handleClose} />
          </Modal.Body>
        </Modal>
      )}
    </>
  );
}

export default LoginModal;
